module.exports = __webpack_public_path__ + "static/media/visa-logo.d7418ad3.png";